import { Component, EventEmitter, Input, Output } from '@angular/core'
import { MediaInterface } from '../../../interfaces'

@Component({
  selector: 'dmmp-result-view',
  templateUrl: './result-view.component.html',
})
export class ResultViewComponent {
  @Input() programmesResult: any
  @Input() identifier: string
  @Output() anchorCustom = new EventEmitter()
  @Output() redirectPage = new EventEmitter()
  @Input() durationLabel = 'Duración: '
  @Input() modalityLabel = 'Modalidad: '
  medias: MediaInterface[] = [
    {
      media: '(min-width:260px) AND (max-width:989px)',
      style: '289x290'
    },
    {
      media: '(min-width:990px)',
      style: 'file_entity_browser_thumbnail'
    }
  ]
}
